import './Loader.scss';

export const Loader = () => (
  <div className="loader" data-cy="loader">
    <div className="loader__content" />
  </div>
);
